import React, { useEffect } from "react";
import Leaderboard from "../../leaderboard";

interface TabLeaderboardProps {
  taskDetail: any;
  activeTab: any;
}

const TabLeaderboard: React.FC<TabLeaderboardProps> = ({
  taskDetail,
  activeTab,
}) => {
  return (
    <div style={{ padding: "0" }}>
      <Leaderboard task_id={taskDetail[0].task_id} activeTab={activeTab} />
    </div>
  );
};

export default TabLeaderboard;
